const Footer = () => {
  return (
    <div
      style={{
        textAlign: "center",
        marginBottom: 10,
      }}
    >
      Made with ♥ by{" "}
      <a href="https://github.com/gyanish0" style={{ cursor: "pointer" }}>
        Gyanish Shrivastava
      </a>
    </div>
  );
};

export default Footer;
